import { analyticsEventHistory as analyticsEventHistoryDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

export type Props = {
    metric?: string;
}

export const analyticsEventHistory = ({
    metric,
}: Props) => analyticsEventHistoryDiagram({metric});
